// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import PositionController from "./position_controller"
application.register("position", PositionController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

